/**
 * @module get-domain-cookie
 * @version 1.0.0
 * @since Tue Jun 6 2018
 */

// Utils
import { getDY_SR } from "stackerConfig"
import domUtil from "lib/dom/dom-util"

const cookiePolicyPrefix = "cookiePolicyBanner"
const { baseStore } = getDY_SR().config.global

export function isShowEmailSignupModal() {
  let isVisited = localStorage.getItem("showEmailSignupModal")
  isVisited = JSON.parse(isVisited)
  let isShowEmailSignupVisited = true

  if (isVisited !== null && isVisited) {
    isShowEmailSignupVisited = false
  }

  return isShowEmailSignupVisited
}

/* Display cookie policy if there is no cookie present */
export function showCookiePolicyBanner() {
  const cookiePolicyBannerElem = domUtil.findFirst("#cookiePolicyBanner")
  domUtil.removeClass(cookiePolicyBannerElem, "hide")
  domUtil.addClass(cookiePolicyBannerElem, "show")
}

/* Remove cookie policy banner on clicking close icon */
export function removeCookiePolicyBanner() {
  const cookiePolicyBannerElem = domUtil.findFirst("#cookiePolicyBanner")
  domUtil.removeClass(cookiePolicyBannerElem, "show")
  domUtil.addClass(cookiePolicyBannerElem, "hide")
}

/* Adding cookie policy banner cookie to avoid displaying again */
export function disableCookiePolicyBanner() {
  localStorage.setItem(`${cookiePolicyPrefix}_${baseStore}`, true)
}

/* On clicking I Accept btn - adding cookie and closing banner */
export function removeAndDisableCookiePolicyBanner() {
  removeCookiePolicyBanner()
  disableCookiePolicyBanner()
}

/* Checking if cookie present if not displaying banner */
export function isCookiePolicyExists() {
  let isCookiePolicyExist = localStorage.getItem(
    `${cookiePolicyPrefix}_${baseStore}`
  )
  isCookiePolicyExist = JSON.parse(isCookiePolicyExist)

  if (!isCookiePolicyExist) {
    showCookiePolicyBanner()
    const acceptBtnElem = domUtil.findFirst(
      "#removeAndDisableCookiePolicyBanner"
    )
    if (acceptBtnElem) {
      acceptBtnElem.addEventListener(
        "click",
        removeAndDisableCookiePolicyBanner
      )
      acceptBtnElem.addEventListener(
        "touchend",
        removeAndDisableCookiePolicyBanner
      )
    }

    const closeBtnElem = domUtil.findFirst("#removeCookiePolicyBanner")
    if (closeBtnElem) {
      closeBtnElem.addEventListener("click", removeAndDisableCookiePolicyBanner)
      closeBtnElem.addEventListener(
        "touchend",
        removeAndDisableCookiePolicyBanner
      )
    }
  }
}

export function isShowCountrySelectModal() {
  const countryDisable = getDY_SR().config.global.countryDisable
  let isShowCountrySelectVisited = false
  if (!countryDisable) {
    let isVisited = localStorage.getItem("showCountrySelectModal")
    isVisited = JSON.parse(isVisited)

    if (!isVisited) {
      isShowCountrySelectVisited = true
    }
  }
  return isShowCountrySelectVisited
}

export function getCookieValue(cname) {
  const name = `${cname}=`
  const ca = document.cookie.split(";")
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === " ") {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ""
}

export function createCookie(cookieObject) {
  const { cookieName, cookieValue, cookiePath, cookieExpiry } = cookieObject
  if (cookiePath) {
    if (cookieExpiry) {
      document.cookie = `${cookieName} =${cookieValue}; expires=${cookieExpiry}; path=/`
    } else {
      document.cookie = `${cookieName} =${cookieValue};path=/`
    }
  } else {
    document.cookie = `${cookieName} =${cookieValue}`
  }
}

isCookiePolicyExists()
